const FEES = `${BACKOFFICE_API_URL}/investor/fees`
const SUPPORTED_COUNTRIES = `${BACKOFFICE_API_URL}/investor/countries`
const FIND_INVESTORS = `${BACKOFFICE_API_URL}/investor`
const ACCOUNTS = `${BACKOFFICE_API_URL}/accounting/trading-accounts`

export default {
  FEES,
  ACCOUNTS,
  SUPPORTED_COUNTRIES,
  FIND_INVESTORS
}
